const _ = require('underscore');
const moreThanZero = function (value) {
    if (value > 0) {
        return true;
    }
    return false;
};
const notEmpty = function (value) {
    return !_.isEmpty(value);
};
module.exports = [
    {
        value: 'flatFee',
        name: 'Flat Fee',
        description: '',
        validators: [
            {
                name: 'rate',
                check: moreThanZero,
            },
        ],
    },
    {
        value: 'percentOfTariff',
        name: '% of Tariff',
        description: '',
        validators: [
            {
                name: 'percent',
                check: moreThanZero,
            },
        ],
    },
    {
        value: 'timeBase',
        name: 'Time Base',
        description: '',
        validators: [
            {
                name: 'rate',
                check: moreThanZero,
            },
            {
                name: 'unit',
                check: notEmpty,
            },
        ],
    },
    {
        value: 'weightBase',
        name: 'Weight Base',
        description: '',
        validators: [
            {
                name: 'rate',
                check: moreThanZero,
            },
        ],
    },
    {
        value: 'vehicleBase',
        name: 'Vehicle Base',
        description: 'The fee is different based on vehicle. ',
        validators: [
            {
                name: 'vehicle_rates',
                check: notEmpty,
            },
        ],
    },
    {
        value: 'passThru',
        name: 'Pass Thru',
        description: 'The fee will be given. ',
        validators: [],
    },
    {
        value: 'specialSurcharge',
        name: 'Special Surcharge',
        description: 'The fee is different based on date. ',
        validators: [
            {
                name: 'special_surcharge',
                check: notEmpty,
            },
        ],
    },
];
